import React, { useState, useEffect } from 'react';

const TranslationJobModal = ({ isOpen, onClose, onSubmit, targetLanguage: initialTargetLanguage }) => {
  const [targetLanguage, setTargetLanguage] = useState('en'); 
  const [translatorEmail, setTranslatorEmail] = useState('');

  // Übernimmt die Sprache, wenn sie als Prop übergeben wird (z.B. beim Klick auf "In Arbeit")
  useEffect(() => {
    if (initialTargetLanguage) {
      setTargetLanguage(initialTargetLanguage);
    } else {
        setTargetLanguage('en'); // Reset auf Default, wenn nichts übergeben wird
    }
  }, [initialTargetLanguage, isOpen]); // Auch bei isOpen resetten/setzen

  const handleSubmit = () => {
    if (targetLanguage.trim() && translatorEmail.trim() && translatorEmail.includes('@')) {
      onSubmit(targetLanguage.trim().toLowerCase(), translatorEmail.trim());
      setTranslatorEmail(''); 
      onClose();
    } else {
      alert("Bitte geben Sie eine gültige Zielsprache (z.B. 'en') und eine gültige E-Mail-Adresse ein.");
    }
  };

  if (!isOpen) return null;

  return (
    <div 
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4" 
        onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-xl w-full max-w-lg mx-auto" 
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Übersetzung beauftragen</h3>
        
        <label htmlFor="target-lang" className="block text-sm font-semibold mb-2 text-gray-900 dark:text-white">Zielsprache (Kürzel):</label>
        <input
          id="target-lang"
          type="text"
          value={targetLanguage}
          onChange={(e) => setTargetLanguage(e.target.value)}
          placeholder="z.B. en, fr, es"
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white mb-4"
        />

        <label htmlFor="translator-email" className="block text-sm font-semibold mb-2 text-gray-900 dark:text-white">E-Mail des Übersetzers:</label>
        <input
          id="translator-email"
          type="email"
          value={translatorEmail}
          onChange={(e) => setTranslatorEmail(e.target.value)} 
          placeholder="name@beispiel.de"
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
        />

        <div className="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
          >
            Auftrag senden
          </button>
        </div>
      </div>
    </div>
  );
};

export default TranslationJobModal;